export const dragAndDropTokens = {
  component: {
    dragAndDrop: {
      item: {
        borderWidth: {
          value: '1px',
          type: 'dimension',
        },
        borderStyle: {
          value: 'solid',
          type: 'strokeStyle',
        },
        borderColor: {
          value: '#dadada',
          type: 'color',
        },
        borderRadius: {
          value: '12px',
          type: 'dimension',
        },
        marginBottom: {
          value: '8px',
          type: 'dimension',
        },
        backgroundColor: {
          value: '#ffffff',
          type: 'color',
        },
        minHeight: {
          value: '48px',
          type: 'dimension',
        },
        default: {
          boxShadow: {
            value: {
              layers: [
                {
                  inset: false,
                  offsetX: '0px',
                  offsetY: '0px',
                  blur: '0px',
                  spread: '0px',
                  color: '#00000000',
                },
              ],
              stringValue: '0px 0px 0px 0px #00000000',
            },
            type: 'shadow',
          },
        },
        dragging: {
          borderColor: {
            value: '#282e37',
            type: 'color',
          },
          boxShadow: {
            value: {
              layers: [
                {
                  inset: false,
                  offsetX: '0px',
                  offsetY: '32px',
                  blur: '32px',
                  spread: '0px',
                  color: '#0000001A',
                },
                {
                  inset: false,
                  offsetX: 0,
                  offsetY: '0px',
                  blur: '2px',
                  spread: '0px',
                  color: '#00000040',
                },
              ],
              stringValue:
                '0px 32px 32px 0px #0000001A, 0 0px 2px 0px #00000040',
            },
            type: 'shadow',
          },
        },
        hover: {
          borderColor: {
            value: '#a0a2a5',
            type: 'color',
          },
        },
        focus: {
          borderColor: {
            value: '#282e37',
            type: 'color',
          },
          outlineWidth: {
            value: '2px',
            type: 'dimension',
          },
          outlineOffset: {
            value: '1px',
            type: 'dimension',
          },
          outlineStyle: {
            value: 'solid',
          },
          outlineColor: {
            value: '#0b4cce',
            type: 'color',
          },
        },
        inMove: {
          borderColor: {
            value: '#282e37',
            type: 'color',
          },
        },
        first: {
          padding: {
            value: '12px',
            type: 'dimension',
          },
          width: {
            value: '48px',
            type: 'dimension',
          },
        },
        last: {
          paddingTop: {
            value: '12px',
            type: 'dimension',
          },
          paddingRight: {
            value: '12px',
            type: 'dimension',
          },
          paddingBottom: {
            value: '12px',
            type: 'dimension',
          },
          paddingLeft: {
            value: '0px',
            type: 'dimension',
          },
          minWidth: {
            value: '1px',
          },
        },
        handle: {
          color: {
            value: '#282e37',
            type: 'color',
          },
        },
      },
      placeholder: {
        borderWidth: {
          value: '1px',
          type: 'dimension',
        },
        borderStyle: {
          value: 'solid',
          type: 'strokeStyle',
        },
        borderColor: {
          value: '#f3f3f3',
          type: 'color',
        },
        borderRadius: {
          value: '12px',
          type: 'dimension',
        },
        marginBottom: {
          value: '8px',
          type: 'dimension',
        },
        backgroundColor: {
          value: '#f3f3f3',
          type: 'color',
        },
        minHeight: {
          value: '48px',
          type: 'dimension',
        },
      },
    },
  },
};
